import {Box, Container, Grid, Stack, styled} from '@mui/material';
import Bg from 'assets/images/svg/bg-homepage/down-app-2-bg.svg';
import {HeaderText} from 'components';
import {AppStoreButton} from './AppStoreButton';
import {CHPlayButton} from './CHPlayButton';
import PhoneHalfImg from 'assets/images/home/mobile-half.png';
import {useTranslation} from 'react-i18next';

const DownApp2 = ({buyCrypto}) => {
  const {t} = useTranslation();
  return (
    <Container>
      <BgContainer>
        <Grid container height="100%" px={{md: 17, xs: 0}} pt={{md: 0, xs: 9}}>
          <Grid item md={7} xs={12}>
            <Stack height="100%" justifyContent="center" spacing={8.5}>
              <HeaderText
                textAlign={{md: 'left', xs: 'center'}}
                isSmall={false}
                sx={{color: (theme) => theme.palette.common.white}}>
                {buyCrypto ? t('buy_crypto.purpose') : t('homepage.purpose')}
              </HeaderText>
              <Stack
                direction={{sm: 'row', xs: 'column'}}
                alignItems="center"
                justifyContent={{xs: 'center', md: 'flex-start'}}
                spacing={1.5}>
                <AppStoreButton />
                <CHPlayButton />
              </Stack>
            </Stack>
          </Grid>
          <Grid
            item
            md={5}
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'flex-end',
            }}>
            <StyleImg src={PhoneHalfImg} alt="" />
          </Grid>
        </Grid>
      </BgContainer>
    </Container>
  );
};

const BgContainer = styled(Container)(({theme}) => ({
  backgroundImage: `url(${Bg})`,
  backgroundRepeat: 'no-repeat',
  borderRadius: theme.spacing(1.25),

  [theme.breakpoints.up('md')]: {
    height: theme.spacing(61),
  },

  [theme.breakpoints.down('md')]: {
    backgroundSize: 'auto 100%',
    height: theme.spacing(77),
  },
}));

const StyleImg = styled('img')(({theme}) => ({
  [theme.breakpoints.down('md')]: {
    width: theme.spacing(20),
  },
}));

export {DownApp2};
